import { ReactNode } from 'react';
import { AdditionalProps } from './types';
import { ContentBlockStyled } from './styled';

export type ContentBlockProps = {
  children: ReactNode;
} & AdditionalProps;

export const ContentBlock = ({ children, ...otherProps }: ContentBlockProps) => {
  return <ContentBlockStyled {...otherProps}>{children}</ContentBlockStyled>;
};
